/**
 * Marketplace vendor-register reads for the static adapter.
 *
 * All four throw `NotImplementedError`, deliberately, and this is the honest
 * state rather than a gap waiting to be filled with a fixture.
 *
 * The register is the one vendor database (WO-05). A fixture here would be a
 * second one, reachable in every environment that runs on fixtures — including
 * ones a client can see — and a screen reading it would show a vendor as
 * assessed when nothing has assessed it. That is the exact failure the listing
 * gate exists to prevent, arriving from inside our own adapter.
 *
 * A caller therefore fails loudly and names the method, rather than rendering
 * an empty list that reads as "there are no assessed vendors".
 *
 * Wiring one means moving it out of this file and deleting its name from
 * `STILL_STUBBED` in `tests/data/vendorRegisterStubs.test.ts`. That second edit
 * is not bureaucracy: it makes "we wired a read" a visible line in a diff.
 */

import { NotImplementedError } from '../ports';
import type { VendorRegisterPort } from '../ports';

export const vendorRegister: VendorRegisterPort = {
  search: () => Promise.reject(new NotImplementedError('vendorRegister.search')),
  getAssessment: () => Promise.reject(new NotImplementedError('vendorRegister.getAssessment')),
  createOnboardingRequest: () =>
    Promise.reject(new NotImplementedError('vendorRegister.createOnboardingRequest')),
  getOnboardingRequest: () =>
    Promise.reject(new NotImplementedError('vendorRegister.getOnboardingRequest')),
};
